module.exports = __webpack_public_path__ + "img/left_md_2.34a25c17.jpg";